<div >
  <span class="action-wrap" #wrap (click)="onToggle()">
    <ng-content></ng-content>
  </span>
</div>

<ng-template #dropArea let-payload>
  <div
    *ngIf="{animate: (animation$ | async)} as streams$"
    class="drop-area"
    (click)="onClick($event)"
    [@dropdown]="(streams$.animate) ? 'open' : 'close'"
    [style]="{top: payload?.top,  left: payload?.left || 'auto', right: payload?.right || 'auto'}">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</ng-template>







